module.exports = __webpack_public_path__ + "static/media/favorit-star-ikon-dc6400.a53f685a.png";